// Endpoints.
export const DAWA_ENDPOINT = 'https://dawa.aws.dk';
export const API_ENDPOINT = '/tryg/api';
export const DEBUG_ENDPOINT = '/tryg/api/debug';
export const PACKAGE_ENDPOINT = '/tryg/api/json_page';

// Actions.
export const API_LOADING = 'API_LOADING';
export const API_LOADED = 'API_LOADED';

export const OAUTH_REQUEST = 'OAUTH_REQUEST';
export const OAUTH_RECEIVE = 'OAUTH_RECEIVE';

export const SERVICES_LOADING = 'SERVICES_LOADING';
export const SERVICES_LOADED = 'SERVICES_LOADED';

// Customer actions.
export const CUSTOMER_CREATE = 'CUSTOMER_CREATE';
export const CUSTOMER_CREATED = 'CUSTOMER_CREATED';
export const CUSTOMER_UPDATE = 'CUSTOMER_UPDATE';
export const CUSTOMER_UPDATED = 'CUSTOMER_UPDATED';
export const CUSTOMER_QUOTE = 'CUSTOMER_QUOTE';
export const CUSTOMER_QUOTED = 'CUSTOMER_QUOTED';
export const CUSTOMER_GET_ACTIVATION_DATE = 'CUSTOMER_GET_ACTIVATION_DATE';
export const CUSTOMER_RECEIVED_ACTIVATION_DATE = 'CUSTOMER_RECEIVED_ACTIVATION_DATE';
export const CUSTOMER_RECEIVED_ACTIVATION_DATES = 'CUSTOMER_RECEIVED_ACTIVATION_DATES';
export const UPDATE_QUOTE = 'UPDATE_QUOTE';
export const UPDATED_QUOTE = 'UPDATED_QUOTE';
export const PORTRAIT_LEAD = 'PORTRAIT_LEAD';
export const PORTRAIT_LEAD_CREATED = 'PORTRAIT_LEAD_CREATED';
export const LEAD_CREATE = 'LEAD_CREATE';
export const GENERATE_LEAD = 'GENERATE_LEAD';
export const LEAD_CREATED = 'LEAD_CREATED';

// Address actions.
export const GET_ADDRESS_AUTOSUGGEST = 'GET_ADDRESS_AUTOSUGGEST';
export const GET_ADDRESS = 'GET_ADDRESS';

// Cyber actions.
export const CVR_SERVICE = 'CVR_SERVICE';
export const CVR_SERVICE_CALL = 'CVR_SERVICE_CALL';
export const CVR_VALID = 'CVR_VALID';
export const CVR_VALIDATED = 'CVR_VALIDATED';

// Car actions.
export const CAR_CREATE = 'CAR_CREATE';
export const CAR_CREATED = 'CAR_CREATED';
export const CAR_UPDATE = 'CAR_UPDATE';
export const CAR_UPDATED = 'CAR_UPDATED';
export const CAR_PREPARE = 'CAR_PREPARE';
export const CAR_PREPARED = 'CAR_PREPARED';
export const CAR_REGISTRATION_NUMBER_VALID = 'CAR_REGISTRATION_NUMBER_VALID';
export const CAR_REGISTRATION_NUMBER_VALIDATED = 'CAR_REGISTRATION_NUMBER_VALIDATED';
export const CAR_UPDATE_MILEAGE = 'CAR_UPDATE_MILEAGE';
export const CAR_TJM_CREATE_PAYMENT = 'CAR_TJM_CREATE_PAYMENT';
export const CAR_TJM_CREATED_PAYMENT = 'CAR_TJM_CREATED_PAYMENT';

// Travel actions.
export const TRAVEL_AUX_GET_PRICE_REQUEST = 'TRAVEL_AUX_GET_PRICE_REQUEST';
export const TRAVEL_AUX_GET_PRICE_REQUESTED = 'TRAVEL_AUX_GET_PRICE_REQUESTED';
export const TRAVEL_CREATE = 'TRAVEL_CREATE';
export const TRAVEL_CREATED = 'TRAVEL_CREATED';
export const TRAVEL_UPDATE = 'TRAVEL_UPDATE';
export const TRAVEL_UPDATED = 'TRAVEL_UPDATED';
export const TRAVEL_PREPARE = 'TRAVEL_PREPARE';
export const TRAVEL_PREPARED = 'TRAVEL_PREPARED';

// Household actions.
export const HOUSEHOLD_CREATE = 'HOUSEHOLD_CREATE';
export const HOUSEHOLD_CREATED = 'HOUSEHOLD_CREATED';
export const HOUSEHOLD_UPDATE = 'HOUSEHOLD_UPDATE';
export const HOUSEHOLD_UPDATED = 'HOUSEHOLD_UPDATED';
export const HOUSEHOLD_PREPARE = 'HOUSEHOLD_PREPARE';
export const HOUSEHOLD_PREPARED = 'HOUSEHOLD_PREPARED';
export const HOUSEHOLD_COV_STATE_UPDATED = 'HOUSEHOLD_COV_STATE_UPDATED';
export const HOUSEHOLD_AUX_UPDATED = 'HOUSEHOLD_AUX_UPDATED';
export const HOUSEHOLD_ADDRESS_RECEIVE_ERROR = 'HOUSEHOLD_ADDRESS_RECEIVE_ERROR';
export const HOUSEHOLD_ADDRESS_RECEIVED_ERROR = 'HOUSEHOLD_ADDRESS_RECEIVED_ERROR';
export const HOUSEHOLD_ADDRESS_RECEIVE = 'HOUSEHOLD_ADDRESS_RECEIVE';
export const HOUSEHOLD_ADDRESS_RECEIVED = 'HOUSEHOLD_ADDRESS_RECEIVED';

// Pregnancy actions.
export const PREGNANCY_CREATE = 'PREGNANCY_CREATE';
export const PREGNANCY_CREATED = 'PREGNANCY_CREATED';
export const PREGNANCY_UPDATE = 'PREGNANCY_UPDATE';
export const PREGNANCY_UPDATED = 'PREGNANCY_UPDATED';
export const PREGNANCY_PREPARE = 'PREGNANCY_PREPARE';
export const PREGNANCY_PREPARED = 'PREGNANCY_PREPARED';
export const PREGNANCY_COV_STATE_UPDATED = 'PREGNANCY_COV_STATE_UPDATED';

// Purchase actions.
export const PURCHASE = 'PURCHASE';
export const PURCHASED = 'PURCHASED';


// Deposit actions.
export const DEPOSIT_CREATE = 'DEPOSIT_CREATE';
export const DEPOSIT_CREATED = 'DEPOSIT_CREATED';
export const DEPOSIT_UPDATE = 'DEPOSIT_UPDATE';
export const DEPOSIT_UPDATED = 'DEPOSIT_UPDATED';
export const DEPOSIT_PREPARE = 'DEPOSIT_PREPARE';
export const DEPOSIT_PREPARED = 'DEPOSIT_PREPARED';
export const DEPOSIT_COMPANY_INFO_VALID = 'DEPOSIT_COMPANY_INFO_VALID';
export const DEPOSIT_COMPANY_INFO_VALIDATED = 'DEPOSIT_COMPANY_INFO_VALIDATED';
export const DEPOSIT_UPDATE_MILEAGE = 'DEPOSIT_UPDATE_MILEAGE';

// Consent actions.
export const CONSENT_TYPES_RECIEVED = 'CONSENT_TYPES_RECIEVED';

export const CONSENT_TYPES = 'consent-types';
export const CONSENT_CREATE = 'CONSENT_CREATE';
export const CONSENT_CREATED = 'CONSENT_CREATED';
export const CONSENT_TYPE_CREATED = 'CONSENT_TYPE_CREATED';
export const ENTERPRISE_APPLICATION_ID = 'TBD';
export const APPLICATION_NAME = 'TBD';

// TJM Payment Action
export const PAYMENT_CREATE = 'PAYMENT_CREATE';
export const PAYMENT_CREATED = 'PAYMENT_CREATED';

//COMMON ACTIONS
export const BANK_ACCOUNT_VALID = 'BANK_ACCOUNT_VALID';